import ApplicationController from "./application_controller.js";

export default class extends ApplicationController {
  static values = {
    caseId: String,
    baseUrl: String,
    transactionId: String,
    multiSelect: Boolean,
    siteId: String,
  };
  static targets = [
    "sharepointTree",
    "upload",
    "sharepointListContent",
    "navigation",
  ];

  connect() {
    // this.insertTable();
    this.render();
  }
  insertTable() {
    const tableTemplate = document.getElementById("sharepoint-list-tree-tpl");
    if (tableTemplate) {
      document
        .getElementById("sharepointDocuments")
        .replaceChildren(tableTemplate.content.cloneNode(true));
    }
  }

  fetchSiteName() {
    return fetch(`${this.baseUrlValue}/sitename`)
      .then((response) => response.json())
      .then((data) => {
        let breadCrumbStart = document.getElementById("breadcrumbStart");
        breadCrumbStart.textContent = data.sitename;
      })
      .catch((error) => {
        console.error("Error fetching site name:", error);
        throw error;
      });
  }

  setUpSpinner() {
    if (document.getElementById("spinnerplace") == null) {
      const spinnerDiv = document.createElement("div");

      spinnerDiv.id = "spinnerplace";
      spinnerDiv.style.display = "flex";
      spinnerDiv.style.justifyContent = "center";
      spinnerDiv.style.alignItems = "center";

      const spinnerImg = document.createElement("img");

      spinnerImg.src = "../resources/leaflet/locate/images/spinner.gif";
      spinnerImg.style.width = "30px";
      spinnerImg.style.height = "30px";

      spinnerDiv.appendChild(spinnerImg);

      document.getElementById("sharepointListContent").appendChild(spinnerDiv);
    }
  }
  render() {
    this.setUpSpinner();
    const baseUrl = this.baseUrlValue;

    fetch(`${baseUrl}/get/drives/`)
      .then((response) => {
        if (response.headers.get("Content-Length") > 2) {
          return response.json();
        } else {
          document.getElementById("sharepointDocuments").style.display = "none";
          const items = document.querySelectorAll("div.bg-info");
          const size = items.length;
          const uploadSharepointDiv = items[size - 1];
          // Create a new <span> element
          const span = document.createElement("span");
          span.textContent = `The Upload from SharePoint feature is not available for this user. 
            To use the feature please ensure you log into iCasework using OpenID SSO as a user with access to the SharePoint site ${this.siteIdValue}.
            Please contact your system administrator for further information`;
          span.style.fontWeight = "bold";
          uploadSharepointDiv.appendChild(span);
          return false;
        }
      })
      .then((data) => {
        if (!document.getElementById("navigationList")) {
          let homeLiEl = document.createElement("li");
          homeLiEl.innerHTML = `<a id="breadcrumbStart" href="#" data-sharepoint-list-target="navigation" data-action="click->sharepoint-list#render">Site Name</a>`;
          let ulEl = document.createElement("ul");
          ulEl.id = "navigationList";
          ulEl.className = "breadcrumb";

          ulEl.append(homeLiEl);
          let navigationDiv = document.createElement("div");
          navigationDiv.append(ulEl);
          document
            .getElementById("sharepointListContent")
            .prepend(navigationDiv);
        } else {
          this.removeNavigationElement("Home");
        }
        this.sharepointTreeTarget.innerHTML =
          this.getHeaderRow() +
          this.getRecentFilesRow() +
          this.nodeToRows(data, true);

        sessionStorage.setItem("driveId", this.getDriveId());

        document.getElementById("spinnerplace").style.display = "none";
        this.fetchSiteName();
        //initiate the treetable
        $("#tree_query").treetable({
          expandable: true,
          indent: 10,
        });
      })
      .then(() => {})
      .catch(console.error);
  }
  //using the json data to see if this is the top level
  //if not recurse through and return the correct row
  nodeToRows(node, isDrive, isFile) {
    let nodeCollection = ``;
    for (let i = 0; i <= node.length - 1; i++) {
      nodeCollection = nodeCollection.concat([
        this.nodeToRow(node[i], isDrive, isFile),
      ]);
    }
    return nodeCollection;
  }
  //turning the nodes from the json data into table rows that treetable can use
  //to create the hierachy
  nodeToRow(node, isDrive, isFile) {
    let rootLevel,
      subLevel,
      isFolder = false;
    if (node.downloadUrl === "null" && !isFile) {
      isFolder = true;
    }

    let dataAction = isDrive
      ? "click->sharepoint-list#fetchDriveContents"
      : "click->sharepoint-list#fetchFolderContents";

    const inputType = this.multiSelectValue ? "checkbox" : "radio";
    const inputName = this.multiSelectValue ? `${node.name}` : "radioFile";
    const dateModified = moment(`${node.lastModifiedDateTime}` * 1).format(
      "DD/MM/YYYY HH:mm:ss",
    );

    let fileIconClass = this.getFileIconClassName(`${node.name}`);
    let topLevelClass = isDrive
      ? "fa-regular fa-hard-drive"
      : "fa-regular fa-folder";

    rootLevel = `<tr data-tt-id="${node.id}" data-sharepoint-list-target="sharepointTree" data-action="${dataAction}" data-context-menu-folderid-param="${node.id}" data-context-menu-parentfolderid-param="${node.parentDriveId}" data-context-menu-foldername-param="${node.name}" class="leaf">
    <td></td><td>&nbsp;<i style='padding-top: 4px; padding-bottom: 4px;' class='${topLevelClass}' aria-hidden="true">&nbsp;</i></td><td><a href="#">${node.name}</a></td><td>${dateModified}</td><td>${node.lastModifiedByUserName}</td></tr>`;
    subLevel =
      `<tr data-tt-id="${node.id}" data-sharepoint-list-target="sharepointTree" class="leaf">
      <td><div class="checkbox-container"><input type="${inputType}" id="${node.name}" name="${inputName}" value="${node.id}"><label for="${node.name}" class="checkbox-label"> </label></div></td><td>&nbsp;<i style='padding-top: 4px; padding-bottom: 4px;' class='${fileIconClass}' aria-hidden="true">&nbsp;</i> </td><td>` +
      '<a aria-label="Open (opens in a new window)"' +
      ' style="padding-right:0.25em" ' +
      ' title="Open (opens in a new tab)"' +
      ` href="${node.webUrl}?action=embedview&wdbipreview=true" ` +
      ' target="_blank"' +
      `>${node.name}</a>` +
      `</td><td>${dateModified}</td><td>${node.lastModifiedByUserName == null ? "" : node.lastModifiedByUserName}</td></tr>`;

    return isFolder ? rootLevel : subLevel;
  }

  uploadFilesFromSharepoint() {
    this.uploadFilesIntoSystem();
  }

  getContentType(filename) {
    const index = filename.indexOf(".");
    const expr = filename.substring(index + 1, filename.length);
    let contentType =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

    if (expr == "jpg" || expr == "jpeg") {
      contentType = "image/jpeg";
    } else if (expr == "doc") {
      contentType = "application/msword";
    } else if (expr == "pdf") {
      contentType = "application/pdf";
    } else if (expr == "png") {
      contentType = "image/png";
    } else if (expr == "xlsx") {
      contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    } else if (expr == "xls") {
      contentType = "application/vnd.ms-excel";
    }
    return contentType;
  }

  getFileIconClassName(filename) {
    const index = filename.indexOf(".");
    const expr = filename.substring(index + 1, filename.length);
    let fileIconClass = "fa-regular fa-file";

    if (expr == "jpg" || expr == "jpeg" || expr == "png") {
      fileIconClass = "fa-regular fa-file-image";
    } else if (expr == "doc" || expr == "docx") {
      fileIconClass = "fa-regular fa-file-word";
    } else if (expr == "pdf") {
      fileIconClass = "fa-regular fa-file-pdf";
    } else if (expr == "xlsx" || expr == "xls") {
      fileIconClass = "fa-regular fa-file-excel";
    } else if (expr == "pptx") {
      fileIconClass = "fa-regular fa-file-powerpoint";
    } else if (expr == "xml") {
      fileIconClass = "fa-regular fa-file-code";
    }
    return fileIconClass;
  }

  // Function to get all the values of checked checkboxes
  getCheckedCheckboxValues() {
    const checkboxValues = [];
    const checkboxes = document.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    checkboxes.forEach((checkbox) => {
      checkboxValues.push(checkbox.value);
    });
    return checkboxValues;
  }

  getSelectedRadioValue() {
    const radioButtons = document.querySelectorAll(
      'input[type="radio"]:checked',
    );
    const checkboxValues = [];
    if (radioButtons.length > 0) {
      checkboxValues.push(radioButtons[0].value);
    }
    return checkboxValues;
  }

  getSelectedRadioId() {
    const radioButtons = document.querySelectorAll(
      'input[type="radio"]:checked',
    );
    const checkboxValues = [];
    if (radioButtons.length > 0) {
      checkboxValues.push(radioButtons[0].id);
    }
    return checkboxValues;
  }

  getCheckedCheckboxName() {
    const checkboxValues = [];
    const checkboxes = document.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    checkboxes.forEach((checkbox) => {
      checkboxValues.push(checkbox.name);
    });
    return checkboxValues;
  }

  async uploadFilesIntoSystem() {
    const filesArray = [];
    let checkboxValues, checkboxNames;
    if (this.multiSelectValue) {
      checkboxValues = this.getCheckedCheckboxValues();
      checkboxNames = this.getCheckedCheckboxName();
    } else {
      checkboxValues = this.getSelectedRadioValue();
      checkboxNames = this.getSelectedRadioId();
    }

    try {
      // Map each ID to a promise returned by fetchFileFromSharepoint
      const fetchPromises = checkboxValues.map((id) => {
        return this.fetchFileFromSharepoint(id)
          .then((fileData) => {
            filesArray.push(fileData);
          })
          .catch((error) => {
            console.error(`Error fetching file with ID ${id}:`, error);
          });
      });

      // Wait for all fetchPromises to resolve
      await Promise.all(fetchPromises);

      // Once all files are fetched, submit the form data
      await this.submitFormData(filesArray, checkboxNames);
    } catch (error) {
      console.error("Error uploading files:", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  }

  // Function to create formdata and submit form data
  async submitFormData(filesArray, checkboxNames) {
    // const externalFiles = new Array();
    const formObject =
      document.getElementById("fileUploadSharepoint") == null
        ? document.getElementById("NonStopGov")
        : document.getElementById("fileUploadSharepoint");

    const formData = new FormData(formObject);
    const formAction = formObject.action;

    filesArray.forEach((fileData, index) => {
      const filename = checkboxNames[index];
      const contentType = this.getContentType(filename);
      const file = new File([fileData], filename, {
        type: contentType,
      });
      formData.append("fileName", file, filename);
    });

    fetch(formAction, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        if (this.isReplaceContents(formAction)) {
          return response.text();
        } else {
          return response.url;
        }
      })
      .then((data) => {
        if (this.isReplaceContents(formAction)) {
          document.getElementById("iCaseworkContent").innerHTML = data;
        } else {
          location.href = data;
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }

  fetchFileFromSharepoint(id) {
    return new Promise((resolve, reject) => {
      // Assuming API endpoint to fetch file data based on ID
      const apiUrl = `${this.baseUrlValue}/file/${id}`;
      const driveId = sessionStorage.getItem("driveId");
      fetch(apiUrl, {
        method: "POST",
        headers: {
          //accept: 'application.json',
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(`driveId=${driveId}`),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch file with ID ${id}`);
          }
          return response.blob(); // Assuming API returns a blob representing the file
        })
        .then(resolve)
        .catch(reject);
    });
  }

  isReplaceContents(formAction) {
    return formAction.includes("loadFile") && formAction.includes("type=L");
  }

  fetchFolderContents(ev) {
    if (!ev.detail || ev.detail == 1) {
      let target = ev.currentTarget;
      let parent = target.parentElement;
      let folderId = target.getAttribute("data-context-menu-folderid-param");
      let driveId = target.getAttribute(
        "data-context-menu-parentfolderid-param",
      );
      sessionStorage.setItem("driveId", driveId);
      let folderName = target.getAttribute(
        "data-context-menu-foldername-param",
      );
      let parentfolderId = target.getAttribute(
        "data-context-menu-parentfolderid-param",
      );
      let fromNavigation = target.getAttribute(
        "data-context-menu-fromNavigation-param",
      );
      fetch(`${this.baseUrlValue}/folderItems/${folderId}`, {
        method: "POST",
        headers: {
          //accept: 'application.json',
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(`driveId=${driveId}`),
      })
        .then((response) => response.json())
        .then((data) => {
          if (fromNavigation)
            this.removeNavigationElement(folderId, folderName, parentfolderId);
          this.sharepointTreeTarget.innerHTML =
            this.getHeaderRow() + this.nodeToRows(data, false);
          if (!fromNavigation)
            this.appendNavigationElement(
              folderId,
              folderName,
              parentfolderId,
              false,
            );
          document
            .querySelectorAll('.checkbox-container input[type="checkbox"]')
            .forEach(function (checkbox) {
              checkbox.addEventListener("change", function () {
                console.log("in loop");
                if (this.checked) {
                  this.closest("tr").classList.add("highlighted-row");
                } else {
                  this.closest("tr").classList.remove("highlighted-row");
                }
              });
            });
        })
        .then(() => {})
        .catch(console.error);
    } else {
      return false;
    }
  }

  fetchRecentFiles() {
    fetch(`${this.baseUrlValue}/recent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        this.sharepointTreeTarget.innerHTML =
          this.getHeaderRow() + this.nodeToRows(data, false, true);
        let navigationListEl = document.createElement("li");
        navigationListEl.innerHTML = `Recent files`;
        document.getElementById("navigationList").appendChild(navigationListEl);
      })
      .then(() => {})
      .catch(console.error);
  }

  fetchDriveContents(ev) {
    //prevent double click event invoking call to back end
    if (!ev.detail || ev.detail == 1) {
      let target = ev.currentTarget;
      let parent = target.parentElement;
      let driveId = target.getAttribute("data-context-menu-folderid-param");
      sessionStorage.setItem("driveId", driveId);
      let folderName = target.getAttribute(
        "data-context-menu-foldername-param",
      );
      let parentfolderId = target.getAttribute(
        "data-context-menu-parentfolderid-param",
      );
      let fromNavigation = target.getAttribute(
        "data-context-menu-fromNavigation-param",
      );
      setTimeout(function () {
        ev.target.disabled = true;
      }, 0);

      fetch(`${this.baseUrlValue}/driveItems/${driveId}`)
        .then((response) => response.json())
        .then((data) => {
          if (fromNavigation)
            this.removeNavigationElement(driveId, folderName, parentfolderId);
          this.sharepointTreeTarget.innerHTML =
            this.getHeaderRow() + this.nodeToRows(data);
          if (!fromNavigation)
            this.appendNavigationElement(
              driveId,
              folderName,
              parentfolderId,
              true,
            );
          document
            .querySelectorAll('.checkbox-container input[type="checkbox"]')
            .forEach(function (checkbox) {
              checkbox.addEventListener("change", function () {
                console.log("in loop");
                if (this.checked) {
                  this.closest("tr").classList.add("highlighted-row");
                } else {
                  this.closest("tr").classList.remove("highlighted-row");
                }
              });
            });
        })
        .then(() => {})
        .catch(console.error);
    } else {
      return false;
    }
  }

  fetchParentFolder(ev) {
    let target = ev.currentTarget;
    let parent = target.parentElement;
    let folderId = target.getAttribute("data-context-menu-folderid-param");
    let parentfolderId = target.getAttribute(
      "data-context-menu-parentfolderid-param",
    );

    fetch(`${this.baseUrlValue}/folderItems/${parentfolderId}`)
      .then((response) => response.json())
      .then((data) => {
        this.sharepointTreeTarget.innerHTML =
          this.getHeaderRow() + this.nodeToRows(data, false);
      })
      .then(() => {})
      .catch(console.error);
  }

  appendNavigationElement(folderId, folderName, parentfolderId, isDrive) {
    let navigationListEl = document.createElement("li");
    navigationListEl.id = `li-${folderId}`;
    navigationListEl.setAttribute("folderid", `${folderId}`);
    let dataAction = isDrive
      ? "click->sharepoint-list#fetchDriveContents"
      : "click->sharepoint-list#fetchFolderContents";
    navigationListEl.innerHTML = `<a href="#" data-sharepoint-list-target="navigation" data-action="${dataAction}" data-context-menu-folderid-param="${folderId}" data-context-menu-fromNavigation-param="true"
                                        data-context-menu-foldername-param="${folderName}" data-context-menu-parentfolderid-param="${parentfolderId}">${folderName}</a>`;
    document.getElementById("navigationList").appendChild(navigationListEl);
    document.getElementById("spinnerplace").style.display = "none";
  }

  getHeaderRow() {
    return `<thead><tr><th width="5px"></th><th title="File type" width="5px"><span class="fa-regular fa-file"></span></th><th>Name</th><th>Modified</th><th>Modified by</th></tr></thead>`;
  }

  getRecentFilesRow() {
    return `<tr data-tt-id="recent" data-sharepoint-list-target="sharepointTree" data-action="click->sharepoint-list#fetchRecentFiles" data-context-menu-folderid-param="#" data-context-menu-parentfolderid-param="#" data-context-menu-foldername-param="#" class="leaf">
    <td>&nbsp;</td><td>&nbsp;<i style='padding-top: 4px; padding-bottom: 4px;' class="fa-regular fa-clock" aria-hidden="true">&nbsp;</i></td><td><a href="#">Recent files</a></td><td></td><td></td></tr>`;
  }
  removeNavigationElement(folderId, folderName, parentfolderId) {
    const listElements = document
      .getElementById("navigationList")
      .getElementsByTagName("li");
    const len = listElements.length;
    if (folderId !== "Home") {
      for (let i = 1; i < len; i++) {
        if (listElements[i]) {
          let previousEl = listElements[i].previousElementSibling;
          if (previousEl && previousEl.getAttribute("folderid") === folderId) {
            for (let j = len - 1; j >= i; j--) {
              let listEl = listElements[j];
              listEl.remove();
            }
          }
        }
      }
    } else {
      for (let i = len - 1; i >= 1; i--) {
        let listEl = listElements[i];
        listEl.remove();
      }
    }
    document.getElementById("spinnerplace").style.display = "none";
  }

  getDriveId() {
    // Get all elements with the data-tt-id attribute
    const elements = document.querySelectorAll("[data-tt-id]");

    // Iterate through the elements
    for (const element of elements) {
      // Get the value of the data-tt-id attribute
      const dataTtId = element.getAttribute("data-tt-id");

      // Check if the value is not "recent"
      if (dataTtId !== "recent") {
        // Return the first non-"recent" value
        return dataTtId;
      }
    }

    // Return null if no non-"recent" value is found
    return null;
  }
}
